/* ============================================================================
   FB - Filiz'in Tavsiyesi  (canli renk-uyum upsell motoru) - v3
   - En pahali sepet urunune gore 2 GERCEKTEN tamamlayici (renk-uyumlu) oneri.
   - Akilli renk modeli: temiz notr (beyaz/krem/bej) parlak renge en iyi tamamlayici;
     ton-in-ton; toprak+toprak; CARPISMA (pembe+yesil/haki gibi) bastirilir.
   - Yeni urunler /products.json'dan kendi kendine havuza girer (sunucu guncellemesi YOK).
   - Sepet acilma/kapanma hizina sifir etki. Sepete Ekle temanin akisiyla birebir.
   ========================================================================== */
(function () {
  if (window.__fbFilizReady) return;
  window.__fbFilizReady = 1;

  var CFG = window.__fbFilizCfg || {};
  var DBG = !!CFG.debug;
  var ADDBG=(CFG.addBg||"#3D2E1F"), ADDTX=(CFG.addTx||"#F5EAD8");

  /* ---------- SATIS TAKIBI (Filiz'in Tavsiyesi upsell'i satis yapiyor mu?) ----------
     1) URUN LINKLERINE UTM: Musteri karti tiklayip urun sayfasina gidip alirsa,
        Shopify Analytics > Raporlar > Pazarlama'da kaynak "filizin_tavsiyesi" olarak duser.
        (& isareti HTML icine yazildigi icin &amp; kullanilir; tarayici otomatik & yapar.)
     2) GIZLI LINE-ITEM ETIKETI: "Sepete Ekle" AJAX oldugu icin UTM'e takilmaz; bu yuzden
        eklenen urune gizli bir siparis etiketi (_kaynak) koyariz. Musteri GORMEZ (alt cizgi
        ile basladigi icin sepette/kasada/mailde gizlidir); ama siparis detayinda ve disa
        aktarimda gorunur -> "bu blok satti mi" sorusunu %100 kesin cevaplar.
     İstersen degerleri buradan degistirebilirsin. */
  var FB_UTM = "utm_source=filizin_tavsiyesi&amp;utm_medium=sepet_upsell&amp;utm_campaign=renk_uyumu";
  var FB_KAYNAK = "Filizin Tavsiyesi";
  function log(){ if(DBG){ try{ console.log.apply(console,['[filiz]'].concat([].slice.call(arguments))); }catch(e){} } }

  /* ---------- renk sozlugu: token -> [aile, sicaklik, deger, notr] ---------- */
  var COLORS = {
    "kahve":["kahve","sicak","koyu",1],"kahverengi":["kahve","sicak","koyu",1],
    "camel":["kahve","sicak","orta",1],"taba":["kahve","sicak","orta",1],
    "bej":["bej","sicak","acik",1],"beige":["bej","sicak","acik",1],
    "vizon":["vizon","sicak","orta",1],"fango":["vizon","sicak","orta",1],"mocha":["kahve","sicak","koyu",1],
    "ekru":["krem","sicak","acik",1],"krem":["krem","sicak","acik",1],
    "siyah":["siyah","notr","koyu",1],"antrasit":["antrasit","notr","koyu",1],
    "beyaz":["beyaz","notr","acik",1],"gri":["gri","notr","orta",1],
    "lacivert":["lacivert","soguk","koyu",1],"indigo":["indigo","soguk","koyu",1],
    "mavi":["mavi","soguk","orta",0],"petrol":["petrol","soguk","koyu",0],
    "saks":["mavi","soguk","orta",0],"royal":["mavi","soguk","orta",0],"blue":["mavi","soguk","orta",0],
    "yesil":["yesil","soguk","orta",0],"haki":["haki","sicak","koyu",1],"military":["haki","sicak","koyu",1],"mint":["yesil","soguk","acik",0],
    "bordo":["bordo","sicak","koyu",0],"kirmizi":["kirmizi","sicak","orta",0],"red":["kirmizi","sicak","orta",0],
    "mercan":["mercan","sicak","orta",0],"somon":["mercan","sicak","acik",0],
    "fusya":["fusya","sicak","orta",0],"pembe":["pembe","sicak","acik",0],"pudra":["pembe","sicak","acik",1],
    "murdum":["murdum","soguk","koyu",0],"eflatun":["eflatun","soguk","acik",0],"mor":["mor","soguk","orta",0],
    "sari":["sari","sicak","orta",0],"hardal":["hardal","sicak","koyu",0],
    "turuncu":["turuncu","sicak","orta",0],"orange":["turuncu","sicak","orta",0],
    "turkuaz":["turkuaz","soguk","orta",0],
    "kaplan":["amber","sicak","koyu",1],"akik":["amber","sicak","orta",1],
    "sodalite":["lacivert","soguk","koyu",1],"kehribar":["amber","sicak","orta",1]
  };
  var DEF = ["dogal","sicak","orta",1];
  var JOINS = {"haki yesil":"haki","bebe mavi":"mavi","petrol mavi":"petrol","acik gri":"gri","kirik beyaz":"beyaz","indian red":"red","acik pembe":"pembe","kaplan gozu":"kaplan"};

  /* renk sinif kumeleri (akilli eslestirme icin) */
  var CLEAN={beyaz:1,krem:1,ekru:1,bej:1,beige:1};                                  // temiz acik notr: her seyle gider
  var DARKN={siyah:1,antrasit:1,gri:1,lacivert:1,indigo:1};                         // koyu notr: her seyle gider
  var EARTH={kahve:1,kahverengi:1,camel:1,taba:1,vizon:1,fango:1,mocha:1,haki:1,military:1,hardal:1,bordo:1,kehribar:1,kaplan:1,akik:1,pudra:1,somon:1,mercan:1};
  var GREENS={yesil:1,haki:1,military:1,mint:1};                                    // yesil/haki ailesi
  var WARMBRIGHT={pembe:1,fusya:1,mercan:1,kirmizi:1,red:1,turuncu:1,orange:1,somon:1}; // sicak-canli

  /* klasik tamamlayici AILE ciftleri ("harbiden cok uyumlu" hissi veren stilist eslesmeleri) */
  var COMP={};
  [["mavi","kahve"],["mavi","vizon"],["mavi","turuncu"],
   ["lacivert","kahve"],["lacivert","vizon"],["lacivert","hardal"],["lacivert","mercan"],["lacivert","kirmizi"],["lacivert","sari"],
   ["indigo","kahve"],["indigo","vizon"],["petrol","kahve"],
   ["haki","hardal"],["hardal","gri"],["mor","gri"],["murdum","gri"],["eflatun","gri"],
   ["turkuaz","kahve"],["mercan","kahve"]
  ].forEach(function(p){ COMP[p[0]+"|"+p[1]]=1; COMP[p[1]+"|"+p[0]]=1; });

  var HEX={
    kahve:"#6f4e37",kahverengi:"#6f4e37",camel:"#c19a6b",taba:"#b87333",
    bej:"#d8c3a5",beige:"#d8c3a5",vizon:"#b3a394",fango:"#a89a8c",mocha:"#5a4632",
    ekru:"#e8e0d0",krem:"#efe4cf",siyah:"#2b2b2b",antrasit:"#3a3a3a",
    beyaz:"#f6f2e9",gri:"#9a9a9a",lacivert:"#1f2a44",indigo:"#2e3a59",
    mavi:"#4a73a8",petrol:"#1f6f6f",saks:"#4a73a8",royal:"#3f5ea8",blue:"#4a73a8",
    yesil:"#5f7d52",haki:"#6b6b3a",military:"#5d5a32",mint:"#a8c8a8",
    bordo:"#6e1f2a",kirmizi:"#a83232",red:"#a83232",mercan:"#e07a5f",somon:"#f0a08a",
    fusya:"#b03a6e",pembe:"#e3a8c0",pudra:"#e6cdd4",murdum:"#5a2a40",eflatun:"#9a7ab0",mor:"#6a4a8a",
    sari:"#d9b84a",hardal:"#c9a227",turuncu:"#d2722f",orange:"#d2722f",turkuaz:"#3aa8a8",
    kaplan:"#b5793a",akik:"#c08a4a",kehribar:"#c8893a",sodalite:"#27406b"
  };
  function colHex(k){ return HEX[k] || "#c9b79c"; }

  function norm(s){
    s = (s||"").replace(/İ/g,"I").replace(/ı/g,"i").toLowerCase();
    var m={"ş":"s","ğ":"g","ü":"u","ö":"o","ç":"c","â":"a"};
    return s.replace(/[şğüöçâ]/g,function(c){return m[c]||c;});
  }
  function toneOf(key){ return (key && COLORS[key]) ? COLORS[key] : DEF; }
  function keyOf(title){
    var toks=(title||"").match(/[A-Za-zÇĞİÖŞÜçğıöşüâ]+/g)||[];
    var w=toks.map(norm), i;
    for(i=0;i<w.length-1;i++){ var pair=w[i]+" "+w[i+1]; if(JOINS[pair]&&COLORS[JOINS[pair]]) return JOINS[pair]; }
    for(i=w.length-1;i>=0;i--){ if(COLORS[w[i]]) return w[i]; }
    return "";
  }
  function catOf(pt){
    var p=norm(pt);
    if(p.indexOf("bileklik")>=0) return "bileklik";
    if(p.indexOf("canta")>=0) return "canta";
    if(p.indexOf("kolye")>=0) return "kolye";
    if(p==="elbise"||p.indexOf("> elbise")>=0||p.indexOf(" elbise")>=0) return "elbise";
    if(p.indexOf("takim")>=0) return "takim";
    if(p.indexOf("alt giyim")>=0||p.indexOf("pantolon")>=0||p.indexOf("pantalon")>=0||p.indexOf("etek")>=0||p.indexOf("sort")>=0||p.indexOf("esofman")>=0) return "alt";
    if(p.indexOf("ust giyim")>=0||p.indexOf("bluz")>=0||p.indexOf("gomlek")>=0||p.indexOf("ceket")>=0||p.indexOf("hirka")>=0||p.indexOf("yelek")>=0||p.indexOf("atlet")>=0||p.indexOf("triko")>=0||p.indexOf("tunik")>=0) return "ust";
    return "diger";
  }
  function nounOf(cat, pt){
    if(cat==="kolye")return "kolye"; if(cat==="bileklik")return "bileklik";
    if(cat==="elbise")return "elbise"; if(cat==="takim")return "takım"; if(cat==="canta")return "çanta";
    var n=((pt||"").split(">").pop()||"").trim().toLowerCase();
    n=n.replace(/\b(modelleri|modeli|model)\b/g,"").trim();
    return n||cat;
  }
  function hsh(str){ var h=0; str=""+str; for(var i=0;i<str.length;i++){ h=(h*31+str.charCodeAt(i))>>>0; } return h; }
  function catLabel(c){ return ({ust:"Üst",alt:"Alt",kolye:"Kolye",bileklik:"Bileklik",elbise:"Elbise",takim:"Takım",canta:"Çanta"}[c]||"Parça")+" Önerisi"; }

  /* ---------- AKILLI RENK-UYUM PUANI ---------- */
  function isBright(k){ return !!k && !CLEAN[k] && !DARKN[k] && !EARTH[k]; }
  function clashes(a,b){ return (WARMBRIGHT[a]&&GREENS[b]) || (WARMBRIGHT[b]&&GREENS[a]); }
  function score(sk, ck){
    var s=toneOf(sk), c=toneOf(ck), sB=isBright(sk);
    if(sk && ck && s[0]===c[0]) return (s[2]!==c[2]) ? 97 : 95;   // ton-in-ton (ayni aile)
    if(CLEAN[ck]) return sB ? 97 : 95;                            // temiz notr aday: evrensel tamamlayici
    if(DARKN[ck]) return sB ? 95 : 93;                            // koyu notr aday: guvenli
    if(CLEAN[sk]) return 94;                                      // notr kaynak + renkli aday: hos pop
    if(EARTH[sk] && EARTH[ck]) return 94;                         // toprak + toprak (magaza estetigi)
    if(clashes(sk,ck)) return 85;                                 // CARPISMA (pembe+yesil/haki) bastir
    if(sk && ck && s[0]!==c[0] && COMP[s[0]+"|"+c[0]]) return 96; // klasik tamamlayici aile cifti (lacivert+camel gibi)
    if(s[1]===c[1]) return 91;                                    // ayni sicaklik (analog)
    return 87;                                                    // notr/orta
  }
  function uyum(sk,ck,ia,ib){
    var base=Math.max(85, Math.min(97, score(sk,ck)));           // ham puan 85..97
    var v=92 + Math.round((base-85)/2);                          // 92..98 araligina esle (gercekci his)
    v += ((hsh(ia+"-"+ib)%3)-1);                                 // -1..+1 dogal dagilim (her oneri ayni cikmasin)
    return Math.max(92, Math.min(98, v));                        // taban 92 - tavan 98
  }

  function targets(cat){
    if(cat==="kolye"||cat==="bileklik")return [["ust"],["alt"]];          // Taki kaynak -> Ust + Alt
    if(cat==="ust")return [["alt"],["kolye","bileklik"]];                 // Ust -> Alt + Taki
    if(cat==="alt")return [["ust"],["kolye","bileklik"]];                 // Alt -> Ust + Taki
    if(cat==="elbise")return [["canta"],["kolye","bileklik"]];           // Elbise -> Canta + Taki
    if(cat==="takim")return [["canta"],["kolye","bileklik"]];            // Takim -> Canta + Taki
    if(cat==="canta")return [["elbise","ust"],["kolye","bileklik"]];     // Canta -> Elbise/Ust + Taki
    return [["ust"],["kolye","bileklik"]];                                // bilinmeyen -> Ust + Taki
  }

  /* ---------- neden (3 havuz kombinatorik) ---------- */
  var A=[
   "{r1c} {r1n} ve {r2c} {r2n}, bu {sn} ile aynı sıcaklıkta buluşuyor.",
   "{r1c} {r1n} ile {r2c} {r2n} arasında huzurlu, doğal bir denge var.",
   "Bu {sn}, {r1c} {r1n} ve {r2c} {r2n} ile yumuşacık bir bütüne dönüşüyor.",
   "{r1c} {r1n} ve {r2c} {r2n}, bu {sn} ile aynı dingin paleti paylaşıyor.",
   "{r1c} {r1n} ile {r2c} {r2n}, bu {sn} etrafında sıcak ve zarif bir uyum kuruyor.",
   "{r1c} {r1n} ve {r2c} {r2n} bir araya gelince sakin, yumuşak bir his doğuyor.",
   "Bu {sn} ile {r1c} {r1n} ve {r2c} {r2n}, doğallığın rahatlığını yansıtıyor.",
   "{r1c} {r1n} ve {r2c} {r2n}, tonlarıyla içini ısıtan bir bütünlük yakalıyor.",
   "{r1c} {r1n} ile {r2c} {r2n}, bu {sn} ile zamansız ve sakin bir uyum oluşturuyor.",
   "{r1c} {r1n} ve {r2c} {r2n}, doğal dokuların sıcaklığında buluşuyor.",
   "Bu {sn}, {r1c} {r1n} ve {r2c} {r2n} eşliğinde bohem bir yumuşaklık kazanıyor.",
   "{r1c} {r1n} ile {r2c} {r2n}, bu {sn} ile sade bir zarafet hissi uyandırıyor.",
   "{r1c} {r1n} ve {r2c} {r2n}, bu {sn} ile birbirini tamamlayan bir akış oluşturuyor.",
   "{r1c} {r1n} ile {r2c} {r2n}, bu {sn} ile sıcak, davetkâr bir hava yakalıyor."
  ];
  var B=[
   "Sıcak nötrler birbirini örtüyor, göz yormuyor.",
   "Aynı paletin yumuşak geçişleri dengeyi koruyor.",
   "Doğal dokular sade bir zarafetle birleşiyor.",
   "Renkler birbirini bastırmadan usulca tamamlıyor.",
   "Hafif kontrast, derinliği abartmadan veriyor.",
   "Ton geçişleri huzurlu, davetkâr bir akış sunuyor.",
   "Yalın renkler zahmetsiz bir uyum hissi veriyor.",
   "Toprak tonlarının dinginliği baştan sona hissediliyor.",
   "","",""
  ];
  var C=[
   "Günlük şıklıktan özel anlara kadar her yerde seninle.",
   "Doğallığın huzurunu zarif bir çizgiyle taşırsın.",
   "Bohem bir rahatlık, zahmetsiz bir zarafet.",
   "Sabahtan akşama dek dengeli ve rahat bir şıklık.",
   "Sade, sıcak ve dingin bir duruşun olur.",
   "Kendini iyi hissettiren, yormayan bir bütün.",
   "Hafif, akışkan ve zamansızca şık.",
   "Her ortamda rahat, her bakışta zarif.",
   "Üzerinde huzur, ruhunda sıcaklık.",
   "Zarif ama abartısız; tıpkı kendin gibi.",
   "Mevsim geçişlerinin gözdesi olacak bir uyum.",
   "Gardırobunun en rahat şıklığı.",
   "Akşam ışığında bile sıcaklığını koruyan bir denge.",
   "Sade bir lüks, gün boyu yanında."
  ];
  var PRETTY={"yesil":"yeşil","murdum":"mürdüm","fusya":"fuşya","blue":"mavi","red":"kırmızı","orange":"turuncu","beige":"bej","military":"haki","royal":"mavi","sodalite":"lacivert"};
  var NEU=["doğal","sade","yumuşak","zarif"];
  function pretty(k){ return PRETTY[k]||k; }
  function neuFor(id){ return NEU[hsh("n"+id)%NEU.length]; }
  function fmt(t,d){ return t.replace(/\{(\w+)\}/g,function(_,k){ return d[k]!=null?d[k]:""; }); }
  function pickPool(pool,tag,seed){ return pool[hsh(tag+seed)%pool.length]; }
  function endStem(s){ var w=(s||"").replace(/[.!?,;]+$/,"").trim().split(/\s+/).pop()||""; return w.toLowerCase().slice(0,3); }
  function neden(srcNoun, r1c,r1n, r2c,r2n, seed, id1, id2){
    var c1 = r1c ? pretty(r1c) : neuFor(id1);
    var c2 = r2c ? pretty(r2c) : neuFor(id2);
    var kk=1;                                                       // ayni "dogal/dogal" tekrari olmasin
    while(kk<NEU.length && c1===c2 && !r2c){ c2=NEU[(hsh("n"+id2)+kk)%NEU.length]; kk++; }
    kk=1; while(kk<NEU.length && c1===c2 && !r1c){ c1=NEU[(hsh("n"+id1)+kk)%NEU.length]; kk++; }
    var d={sn:srcNoun, r1c:c1, r1n:r1n, r2c:c2, r2n:r2n};
    var a=fmt(pickPool(A,"A",seed),d), b=pickPool(B,"B",seed), c=pickPool(C,"C",seed);
    /* ECHO GUARD: ard arda cumleler ayni kok-fiille bitmesin (tekrar hissi olmasin) */
    var as=endStem(a), t2=0;
    while(t2<B.length && b && endStem(b)===as){ b=B[(hsh("B2"+seed)+t2)%B.length]; t2++; }
    var bs=endStem(b), t=0;
    while(t<C.length && c && (endStem(c)===as || (b && endStem(c)===bs))){ c=C[(hsh("C2"+seed)+t)%C.length]; t++; }
    var parts=[a]; if(b) parts.push(b); parts.push(c);
    var txt=parts.join(" ");
    return txt.charAt(0).toUpperCase()+txt.slice(1);
  }

  /* ---------- veri (lazy + cache) ---------- */
  var DATA=null, dataPromise=null;
  function loadData(){
    if(DATA) return Promise.resolve(DATA);
    if(dataPromise) return dataPromise;
    try{ var cs=sessionStorage.getItem("fbfil:data"); if(cs){ DATA=JSON.parse(cs); return Promise.resolve(DATA); } }catch(e){}
    if(!CFG.url) return Promise.reject("no url");
    dataPromise=fetch(CFG.url,{cache:"force-cache"}).then(function(r){return r.json();}).then(function(j){
      DATA=j; try{ sessionStorage.setItem("fbfil:data",JSON.stringify(j)); }catch(e){} return j;
    });
    return dataPromise;
  }

  /* ---------- urun canli veri (cache) ---------- */
  var pcache={};
  function getProduct(handle){
    if(pcache[handle]) return Promise.resolve(pcache[handle]);
    try{ var cs=sessionStorage.getItem("fbfp:"+handle); if(cs){ pcache[handle]=JSON.parse(cs); return Promise.resolve(pcache[handle]); } }catch(e){}
    return fetch("/products/"+handle+".js",{cache:"force-cache"}).then(function(r){ if(!r.ok) throw 0; return r.json(); }).then(function(p){
      pcache[handle]=p; try{ sessionStorage.setItem("fbfp:"+handle,JSON.stringify(p)); }catch(e){} return p;
    });
  }

  /* ---------- aday secimi (akilli renk-uyum siralamasi) ---------- */
  function ranked(srcKey, srcId, cats, used){
    var cands=[],i,j;
    for(i=0;i<cats.length;i++){ var pool=(DATA.cat&&DATA.cat[cats[i]])||[]; for(j=0;j<pool.length;j++){ var a=pool[j]; if(a[0]===srcId||used.indexOf(a[0])>=0) continue; cands.push({cat:cats[i],id:a[0],handle:a[1],ck:a[2],sc:score(srcKey,a[2])}); } }
    cands.sort(function(p,q){
      if(p.sc!==q.sc) return q.sc-p.sc;
      return (hsh(srcId+"-"+p.id)%100003)-(hsh(srcId+"-"+q.id)%100003);
    });
    for(i=0;i<cats.length;i++){ var fb=(DATA.fb&&DATA.fb[cats[i]])||[]; for(j=0;j<fb.length;j++){ var f=fb[j]; if(f[0]===srcId||used.indexOf(f[0])>=0) continue; if(!cands.some(function(x){return x.id===f[0];})) cands.push({cat:cats[i],id:f[0],handle:f[1],ck:"",sc:80}); } }
    return cands;
  }
  function resolveSlot(cands, used, tries){
    tries = tries||0;
    if(!cands.length || tries>=8) return Promise.resolve(null);
    var c=cands[0], rest=cands.slice(1);
    return getProduct(c.handle).then(function(p){
      var av=(p.variants||[]).filter(function(v){return v.available;});
      if(!av.length) return resolveSlot(rest, used, tries+1);
      c.product=p; c.avail=av; return c;
    }).catch(function(){ return resolveSlot(rest, used, tries+1); });
  }

  /* her urunde KUSURSUZ + TUTARLI: hedef kategori -> taki (her zaman uyumlu aksesuar) -> tamamlayici giysi (kaynak tipi haric). Her asama renk-uyumuna gore siralanir; stok yoksa bir sonraki en uyumlu secilir. */
  function resolveCats(srcKey, srcId, cats, srcCat, used){
    return resolveSlot(ranked(srcKey, srcId, cats, used), used).then(function(r){
      if(r) return r;
      return resolveSlot(ranked(srcKey, srcId, ["kolye","bileklik"], used), used).then(function(r2){
        if(r2) return r2;
        var g=["ust","alt","elbise","canta"].filter(function(c){ return c!==srcCat && cats.indexOf(c)<0; });
        return resolveSlot(ranked(srcKey, srcId, g, used), used);
      });
    });
  }

  function mostExpensive(cart){
    var best=null;
    (cart.items||[]).forEach(function(it){
      var u = (typeof it.price==="number")?it.price:(it.final_price||0);
      if(!best || u>best._u){ it._u=u; best=it; }
    });
    return best;
  }

  /* ---------- ana hesaplama ---------- */
  function compute(){
    return loadData().then(function(){
      return fetch("/cart.js",{cache:"no-store",headers:{Accept:"application/json"}}).then(function(r){return r.json();});
    }).then(function(cart){
      if(!cart || !cart.items || !cart.items.length) return null;
      var src=mostExpensive(cart);
      if(!src) return null;
      var srcCat=catOf(src.product_type||"");
      var srcKey=keyOf(src.title||src.product_title||"");
      var srcId=src.product_id;
      var used=[]; (cart.items||[]).forEach(function(it){ if(used.indexOf(it.product_id)<0) used.push(it.product_id); });
      var sig = (cart.items||[]).map(function(it){return it.product_id;}).sort().join(",");
      var t=targets(srcCat);
      return resolveCats(srcKey, srcId, t[0], srcCat, used).then(function(r1){
        if(!r1) return null;
        used.push(r1.id);
        return resolveCats(srcKey, srcId, t[1], srcCat, used).then(function(r2){
          if(!r2) return null;
          function pack(r){
            var p=r.product, v=r.avail[0], ck=(r.ck||keyOf(p.title)||"");
            return {
              id:r.id, handle:r.handle, cat:r.cat, avail:r.avail,
              title:p.title, type:p.type, noun:nounOf(r.cat, p.type), col:ck,
              uyum:uyum(srcKey,ck,srcId,r.id),
              price:v.price, compare:v.compare_at_price||0,
              image:(p.featured_image||(p.images&&p.images[0])||"")
            };
          }
          var R1=pack(r1), R2=pack(r2);
          var srcNoun=nounOf(srcCat, src.product_type||"");
          var why=neden(srcNoun, R1.col, R1.noun, R2.col, R2.noun, sig+"-"+srcId, R1.id, R2.id);
          var avg=Math.round((R1.uyum+R2.uyum)/2);
          return { srcCol:srcKey, neden:why, avg:avg, cards:[R1,R2] };
        });
      });
    }).catch(function(e){ log("compute err",e); return null; });
  }

  /* ---------- money format ---------- */
  function money(cents){
    var fmtStr=CFG.money||"{{amount}} TL";
    try{
      function n(c,p,th,dec){ var s=(c/100).toFixed(p), a=s.split("."); var d=a[0].replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1"+(th||".")); return d+(a[1]?(dec||",")+a[1]:""); }
      var key=(fmtStr.match(/\{\{\s*(\w+)\s*\}\}/)||[,"amount"])[1], val;
      switch(key){
        case "amount": val=n(cents,2,".",","); break;
        case "amount_no_decimals": val=n(cents,0,".",","); break;
        case "amount_with_comma_separator": val=n(cents,2,".",","); break;
        case "amount_no_decimals_with_comma_separator": val=n(cents,0,".",","); break;
        case "amount_with_space_separator": val=n(cents,2," ",","); break;
        case "amount_no_decimals_with_space_separator": val=n(cents,0," ",","); break;
        default: val=n(cents,2,".",",");
      }
      return fmtStr.replace(/\{\{\s*\w+\s*\}\}/, val);
    }catch(e){ return (cents/100).toFixed(2)+" TL"; }
  }
  function esc(s){ return (s||"").replace(/[&<>"\x27]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","\x27":"&#39;"}[c];}); }
  function imgU(url,w){ if(!url)return ""; if(url.indexOf("//")===0)url="https:"+url; return url.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i,function(m,e){return "_"+w+"x"+e;}); }

  /* ---------- render ---------- */
  function swatches(keys){
    var seen={}, h="", i;
    for(i=0;i<keys.length;i++){ var hex=colHex(keys[i]||""), id=hex.toLowerCase(); if(seen[id])continue; seen[id]=1; h+='<span class="fbf__sw" style="background:'+hex+'"></span>'; }
    return h;
  }
  function cardHTML(c, idx){
    var sale = c.compare && c.compare>c.price;
    var sizes = c.avail.length>1 ? c.avail : null;
    var h='<div class="fbf__card" data-handle="'+esc(c.handle)+'">';
    h+='<div class="fbf__clabel">'+(idx+1)+'. '+catLabel(c.cat)+'</div>';
    h+='<a class="fbf__media" href="/products/'+esc(c.handle)+'?'+FB_UTM+'" tabindex="-1">';
    if(c.image) h+='<img class="fbf__img" src="'+esc(imgU(c.image,420))+'" alt="'+esc(c.title)+'" loading="eager" fetchpriority="high" decoding="async">';
    h+='</a>';
    h+='<a class="fbf__title" href="/products/'+esc(c.handle)+'?'+FB_UTM+'">'+esc(c.title)+'</a>';
    h+='<div class="fbf__prices">';
    if(sale){ h+='<span class="fbf__price fbf__price--sale">'+money(c.price)+'</span><span class="fbf__price fbf__price--cmp">'+money(c.compare)+'</span>'; }
    else { h+='<span class="fbf__price">'+money(c.price)+'</span>'; }
    h+='</div>';
    if(sizes){
      h+='<div class="fbf__sizes" role="group" aria-label="Beden seç">';
      sizes.forEach(function(v){ h+='<button type="button" class="fbf__size" data-vid="'+v.id+'">'+esc(v.title)+'</button>'; });
      h+='</div>';
    }
    var firstV = sizes ? "" : String(c.avail[0].id);
    h+='<button type="button" class="fbf__add" style="background:'+ADDBG+' !important;color:'+ADDTX+' !important;border:1px solid '+ADDBG+' !important" data-vid="'+firstV+'"'+(sizes?' data-need-size="1"':'')+'>'
      +'<span class="fbf__add-label">Sepete Ekle</span>'
      +'<svg class="fbf__add-check" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.5 8.5l3 3 6-6.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      +'</button>';
    h+='</div>';
    return h;
  }
  function sheetBodyHTML(pkg){
    var h='';
    h+='<div class="fbf__top"><div class="fbf__toprow1"><div class="fbf__stitle"><svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.2l1.7 5.3a3 3 0 0 0 1.9 1.9L21 11l-5.4 1.7a3 3 0 0 0-1.9 1.9L12 19.8l-1.7-5.2a3 3 0 0 0-1.9-1.9L3 11l5.4-1.6a3 3 0 0 0 1.9-1.9z"/><path d="M5.2 2.8l.5 1.7 1.7.5-1.7.5-.5 1.7-.5-1.7L3 5l1.7-.5z" opacity=".75"/></svg> '+esc(CFG.heading||"Filiz'in Tavsiyesi")+'</div><button type="button" class="fbf__close" aria-label="Kapat" title="Kapat"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div><div class="fbf__toprow2"><div class="fbf__intro">Bu parçalar senin için özel olarak kombinlendi. Renk uyumu ve stil dengesi %'+pkg.avg+' mükemmel.</div><div class="fbf__badge"><span class="fbf__bpct">%'+pkg.avg+'</span><span class="fbf__blbl">Renk Uyumu</span><span class="fbf__bsws">'+swatches([pkg.srcCol,pkg.cards[0].col,pkg.cards[1].col])+'</span></div></div></div>';
    h+='<div class="fbf__cards">'+cardHTML(pkg.cards[0],0)+'<div class="fbf__plus" aria-hidden="true">+</div>'+cardHTML(pkg.cards[1],1)+'</div>';
    h+='<button type="button" class="fbf__addboth"><svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><span class="fbf__addboth-label">Seçilenleri Sepete Ekle</span></button>';
    h+='<div class="fbf__why"><div class="fbf__why-h"><svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6.5 21c-1.2 0-1.5-1-1.5-2.2C5 11 11 4.6 20.5 3.8c.2 8.9-5.2 16-13 17.1-.3.1-.7.1-1 .1zm2.2-3.2c3.9-2 6.7-5.6 8.5-10.4-4.8 1.8-8.4 4.7-10.4 9.4.6.4 1.2.7 1.9 1z"/></svg> Neden Bu Kombini Öneriyoruz?</div><div class="fbf__why-t">'+esc(pkg.neden)+'</div></div>';
    return h;
  }

  /* ---------- sepete ekle (tema ile birebir akis) ---------- */
  function sectionIds(){
    var ids=[]; document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(c){ var id=c.getAttribute('data-section-id'); if(id&&ids.indexOf(id)<0) ids.push(id); }); return ids;
  }
  function addToCart(vid, btn){
    if(!vid){ return; }
    if(btn.classList.contains("is-loading")||btn.classList.contains("is-done")) return;
    btn.classList.add("is-loading");
    var ids=sectionIds();
    var body={ id:vid, quantity:1, properties:{ "_kaynak":FB_KAYNAK } };
    if(ids.length){ body.sections=ids.join(","); body.sections_url=window.location.pathname; }
    fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify(body)})
      .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,data:d}; }); })
      .then(function(res){
        if(!res.ok || res.data.status){ btn.classList.remove("is-loading"); flash(btn,"Eklenemedi"); return; }
        btn.classList.remove("is-loading"); btn.classList.add("is-done");
        try{ btn.style.setProperty("background","#3c7d4f","important"); btn.style.setProperty("border-color","#3c7d4f","important"); }catch(e){}
        var lbl=btn.querySelector(".fbf__add-label"); if(lbl) lbl.textContent="Eklendi";
        document.dispatchEvent(new CustomEvent("cart:update",{ detail:{ resource:undefined, sourceId:"fb-filiz", data:{ source:"fb-filiz", itemCount:res.data.quantity, sections:res.data.sections||{} } }, bubbles:true, cancelable:true }));
      })
      .catch(function(){ btn.classList.remove("is-loading"); flash(btn,"Bağlantı hatası"); });
  }
  function flash(btn,msg){ var lbl=btn.querySelector(".fbf__add-label"); if(!lbl)return; var old=lbl.textContent; lbl.textContent=msg; setTimeout(function(){ lbl.textContent=old; },1800); }
  function flashBoth(btn,msg){ var lbl=btn.querySelector(".fbf__addboth-label"); if(!lbl)return; var old=lbl.textContent; lbl.textContent=msg; setTimeout(function(){ lbl.textContent=old; },1800); }
  function addBoth(btn){
    if(btn.classList.contains("is-loading")||btn.classList.contains("is-done")) return;
    var sheet=btn.closest(".fbf__sheet"); if(!sheet) return;
    var cards=sheet.querySelectorAll(".fbf__card"), items=[], miss=false;
    cards.forEach(function(card){
      var a=card.querySelector(".fbf__add"); if(!a) return;
      if(a.dataset.needSize==="1" && !a.dataset.vid){ miss=true; var sw=card.querySelector(".fbf__sizes"); if(sw){ sw.classList.add("fbf__sizes--hint"); setTimeout(function(){sw.classList.remove("fbf__sizes--hint");},900); } return; }
      if(a.dataset.vid) items.push({id:a.dataset.vid, quantity:1, properties:{ "_kaynak":FB_KAYNAK }});
    });
    if(miss || !items.length) return;
    btn.classList.add("is-loading");
    var ids=sectionIds(), body={ items:items };
    if(ids.length){ body.sections=ids.join(","); body.sections_url=window.location.pathname; }
    fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify(body)})
      .then(function(r){ return r.json().then(function(d){ return {ok:r.ok,data:d}; }); })
      .then(function(res){
        if(!res.ok || res.data.status){ btn.classList.remove("is-loading"); flashBoth(btn,"Eklenemedi"); return; }
        btn.classList.remove("is-loading"); btn.classList.add("is-done");
        var lbl=btn.querySelector(".fbf__addboth-label"); if(lbl) lbl.textContent="Sepete Eklendi";
        sheet.querySelectorAll(".fbf__card .fbf__add").forEach(function(a){ if(a.dataset.vid){ a.classList.add("is-done"); try{ a.style.setProperty("background","#3c7d4f","important"); a.style.setProperty("border-color","#3c7d4f","important"); }catch(e){} var l=a.querySelector(".fbf__add-label"); if(l) l.textContent="Eklendi"; } });
        setTimeout(function(){ document.dispatchEvent(new CustomEvent("cart:update",{ detail:{ source:"fb-filiz", data:{ source:"fb-filiz", sections:res.data.sections||{} } }, bubbles:true, cancelable:true })); }, 950);
      })
      .catch(function(){ btn.classList.remove("is-loading"); flashBoth(btn,"Bağlantı hatası"); });
  }

  /* ---------- enjeksiyon: ince teaser + alttan acilir panel (sheet) ---------- */
  function injectTeaser(dialog){
    if(!dialog.hasAttribute("open")) return;
    if(dialog.querySelector("[data-fb-teaser]")) return;
    var tpl=document.getElementById("fb-filiz-template");
    if(!tpl||!tpl.content) return;
    var summary=dialog.querySelector(".cart-drawer__summary");
    var items=dialog.querySelector(".cart-drawer__items:not(.fb-empty-cart-items)");
    var node=tpl.content.cloneNode(true);
    if(summary&&summary.parentNode){ summary.parentNode.insertBefore(node, summary); }
    else if(items){ items.appendChild(node); }
  }
  var SHEET=null, LAST_PKG=null, OPENER=null;
  function ensureSheet(){
    if(SHEET && document.body.contains(SHEET)) return SHEET;
    var dlg=document.createElement("dialog"); dlg.className="fbf-dialog";
    dlg.setAttribute("aria-label", CFG.heading||"Filiz");
    dlg.innerHTML='<div class="fbf__sheet" role="document"><div class="fbf__sheetbody"></div></div>';
    document.body.appendChild(dlg);
    dlg.addEventListener("click",function(ev){ if(ev.target===dlg){ closeSheet(); return; } if(ev.target.closest&&ev.target.closest(".fbf__close")) closeSheet(); });
    dlg.addEventListener("cancel",function(ev){ ev.preventDefault(); closeSheet(); });
    SHEET=dlg; return dlg;
  }
  function openSheet(){
    var dlg=ensureSheet();
    var b=dlg.querySelector(".fbf__sheetbody");
    // ICERIK GARANTISI: panel asla bos acilmasin. Cache varsa aninda doldur; yoksa hesapla-doldur (panel yine de HEMEN acilir).
    if(b && !b.querySelector(".fbf__card")){
      if(LAST_PKG){ try{ b.innerHTML=sheetBodyHTML(LAST_PKG); }catch(e){} }
      else{ try{ b.innerHTML='<div style="min-height:42vh;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;color:#9a8b78;font-family:inherit;text-align:center;padding:24px;"><span style="width:30px;height:30px;border:3px solid #e6d8c2;border-top-color:var(--fbf-accent,#c0552f);border-radius:50%;display:inline-block;animation:fbf-spin .8s linear infinite;"></span><span style="font-size:14px;font-weight:600;">Filiz senin için hazırlıyor…</span></div>'; }catch(e){} compute().then(function(pkg){ if(pkg && b){ LAST_PKG=pkg; try{ b.innerHTML=sheetBodyHTML(pkg); }catch(e){} positionPlus(b); fitPanel(); } }).catch(function(){}); }
    }
    try{ if(!dlg.open) dlg.showModal(); }catch(e){ try{ dlg.setAttribute("open",""); }catch(_){} }
    if(b) positionPlus(b); fitPanel();
    requestAnimationFrame(function(){ dlg.classList.add("is-open"); requestAnimationFrame(fitPanel); });
  }
  function closeSheet(){
    var dlg=SHEET; if(!dlg) return;
    dlg.classList.remove("is-open");
    setTimeout(function(){
      try{ if(dlg.open && !dlg.classList.contains("is-open")) dlg.close(); }catch(e){ dlg.removeAttribute("open"); }
      try{ var b=dlg.querySelector(".fbf__sheetbody"); if(b) b.innerHTML=""; }catch(e){}
      try{ if(OPENER && OPENER.focus){ OPENER.focus(); } OPENER=null; }catch(e){}
    },460);
  }
  // PC KOK COZUM: gorsel 3:4 oranli; yuksekligi hem DIKEY (scroll yok) hem YATAY (panele sigar) sinirina gore MAKSIMUM (gercek olcum, tahmin yok). Mobil: CSS.
  function fitPanel(){
    var dlg=SHEET; if(!dlg) return;
    var sheet=dlg.querySelector(".fbf__sheet"); if(!sheet) return;
    var media=sheet.querySelector(".fbf__media");
    var cards=sheet.querySelector(".fbf__cards");
    var plus=sheet.querySelector(".fbf__plus");
    var isPC=(!window.matchMedia)||window.matchMedia("(min-width:750px)").matches;
    sheet.style.removeProperty("--fbf-imgh");
    if(!isPC || !media || !cards) return;            // mobilde dokunma
    void sheet.offsetHeight;
    // YATAY tavan: bir kartin gorsel genisligi -> 3:4 yukseklik
    var cs=getComputedStyle(cards); var gap=parseFloat(cs.columnGap||cs.gap)||16;
    var plusW=plus?Math.ceil(plus.getBoundingClientRect().width):30;
    var avail=cards.clientWidth||sheet.clientWidth;
    var maxImgW=Math.floor((avail - plusW - 2*gap)/2);
    var maxH_horiz=maxImgW/0.75;
    var target=Math.floor(0.97*window.innerHeight);  // panel hedef yuksekligi (px)
    for(var i=0;i<10;i++){
      var total=sheet.scrollHeight;                  // mevcut toplam icerik
      var cur=media.getBoundingClientRect().height;  // mevcut gorsel yuksekligi
      var want=cur + (target-total) - 4;             // hedefe yaklas (buyut/kucult)
      if(want>maxH_horiz) want=maxH_horiz;           // yatay tavani asma (yan tasma yok)
      if(want<150) want=150;                         // taban
      if(Math.abs(want-cur)<1.5) break;              // oturdu
      sheet.style.setProperty("--fbf-imgh", Math.floor(want)+"px");
      void sheet.offsetHeight;
    }
  }
  function positionPlus(root){
    try{
      var cards=root.querySelector(".fbf__cards"), plus=root.querySelector(".fbf__plus"), img=root.querySelector(".fbf__card .fbf__img");
      if(!cards||!plus||!img) return;
      plus.style.alignSelf="start"; plus.style.marginTop="0px";
      var cr=cards.getBoundingClientRect(), ir=img.getBoundingClientRect(), pr=plus.getBoundingClientRect();
      var imgCenter=(ir.top+ir.height/2)-cr.top;
      plus.style.marginTop=Math.max(0,Math.round(imgCenter-pr.height/2))+"px";
    }catch(e){}
  }
  var _pre={};
  function preloadImgs(pkg){
    try{ (pkg.cards||[]).forEach(function(c){ var u=imgU(c.image,420); if(!u||_pre[u])return; _pre[u]=1; var im=new Image(); im.decoding="async"; try{im.fetchPriority="high";}catch(e){} im.src=u; }); }catch(e){}
  }
  function fillAll(){
    var teasers=document.querySelectorAll("[data-fb-teaser]");
    var bodies=document.querySelectorAll(".fbf__sheetbody");
    if(!teasers.length && !bodies.length) return;
    compute().then(function(pkg){
      if(!pkg){ teasers.forEach(function(t){ t.style.display="none"; }); return; }
      LAST_PKG=pkg; preloadImgs(pkg);
      teasers.forEach(function(t){
        t.style.display="";
        if(t.getAttribute("data-auto")==="1"){ var sd=ensureSheet(); if(!sd.classList.contains("is-open")) requestAnimationFrame(function(){ openSheet(); }); }
      });
      if(document.querySelector(".fbf-dialog.is-open")) return; // panel acikken icerigi DONDUR (musteri urun degisimini gormesin)
      bodies.forEach(function(b){ try{ b.innerHTML=sheetBodyHTML(pkg); positionPlus(b); }catch(e){ log("fill err",e); } });
    });
  }
  function observeDrawer(comp){
    if(comp.__fbObs) return;
    var d=comp.querySelector("dialog"); if(!d) return;
    try{
      var obs=new MutationObserver(function(){ if(d.hasAttribute("open") && !d.querySelector("[data-fb-teaser]")) injectTeaser(d); });
      obs.observe(d,{childList:true,subtree:true});
      comp.__fbObs=obs;
    }catch(e){}
  }
  function run(){
    document.querySelectorAll("cart-drawer-component").forEach(function(comp){
      var d=comp.querySelector("dialog"); if(!d) return;
      if(!d.__fbFilizClose){ d.__fbFilizClose=true; d.addEventListener("close",function(){ var t=d.querySelector("[data-fb-teaser]"); if(t&&t.parentNode) t.parentNode.removeChild(t); closeSheet(); }); }
      observeDrawer(comp);
      if(!d.hasAttribute("open")) return;
      injectTeaser(d);
    });
    ensureSheet();
    fillAll();
  }

  /* ---------- olaylar ---------- */
  document.addEventListener("fb:cart-drawer-render-fixed", function(){ requestAnimationFrame(run); });
  document.addEventListener("cart:update", function(){ requestAnimationFrame(run); });
  var _fbRsz; window.addEventListener("resize",function(){ clearTimeout(_fbRsz); _fbRsz=setTimeout(function(){ document.querySelectorAll(".fbf-dialog.is-open .fbf__sheetbody").forEach(positionPlus); fitPanel(); },120); });

  document.addEventListener("click",function(e){
    if(!e.target||!e.target.closest||!e.target.closest(".fbf__teaser,.fbf__size,.fbf__addboth,.fbf__add")) return;
    var tz=e.target.closest&&e.target.closest(".fbf__teaser");
    if(tz){ e.preventDefault(); OPENER=tz; openSheet(); return; }
    var sz=e.target.closest&&e.target.closest(".fbf__size");
    if(sz){ e.preventDefault(); var card=sz.closest(".fbf__card"); if(card){ card.querySelectorAll(".fbf__size").forEach(function(b){b.classList.remove("is-sel");}); sz.classList.add("is-sel"); var add=card.querySelector(".fbf__add"); if(add){ add.dataset.vid=sz.dataset.vid; } } return; }
    var ab=e.target.closest&&e.target.closest(".fbf__addboth");
    if(ab){ e.preventDefault(); e.stopPropagation(); addBoth(ab); return; }
    var add=e.target.closest&&e.target.closest(".fbf__add");
    if(add){
      e.preventDefault(); e.stopPropagation();
      if(add.dataset.needSize==="1" && !add.dataset.vid){
        var card=add.closest(".fbf__card"); if(card){ var sw=card.querySelector(".fbf__sizes"); if(sw){ sw.classList.add("fbf__sizes--hint"); setTimeout(function(){sw.classList.remove("fbf__sizes--hint");},900); } }
        return;
      }
      addToCart(add.dataset.vid, add);
    }
  });

  /* ---------- KENDI KENDINE TAZELEME (yeni urunler havuza otomatik) ---------- */
  function poolsFromProducts(prods){
    var cat={};
    for(var i=0;i<prods.length;i++){
      var p=prods[i], c=catOf(p.product_type||"");
      if(c==="diger") continue;
      var ok=false, vs=p.variants||[];
      for(var k=0;k<vs.length;k++){ if(vs[k] && vs[k].available){ ok=true; break; } }
      if(!ok) continue;
      (cat[c]=cat[c]||[]).push([p.id, p.handle, keyOf(p.title)]);
    }
    return cat;
  }
  var refreshing=false;
  function selfRefresh(){
    if(refreshing) return;
    try{ var ts=+(localStorage.getItem("fbfil:ts")||0); if(Date.now()-ts < 6*3600*1000) return; }catch(e){}
    refreshing=true;
    var all=[], page=1;
    function step(){
      fetch("/products.json?limit=250&page="+page,{cache:"no-store"})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(j){
          var ps=(j&&j.products)||[];
          all=all.concat(ps);
          if(ps.length===250 && page<8){ page++; step(); } else fin();
        }).catch(function(){ fin(); });
    }
    function fin(){
      try{
        if(all.length){
          var pools=poolsFromProducts(all), n=0, kk;
          for(kk in pools) n+=pools[kk].length;
          if(DATA && n>30){ DATA.cat=pools; try{ sessionStorage.setItem("fbfil:data",JSON.stringify(DATA)); }catch(e){} log("havuz tazelendi:", n); }
        }
        try{ localStorage.setItem("fbfil:ts",""+Date.now()); }catch(e){}
      }catch(e){ log("refresh err",e); }
      refreshing=false;
    }
    step();
  }

  /* ---------- isitma + tazeleme (kritik yolun disinda) ---------- */
  function warm(){ try{ loadData().then(function(){ selfRefresh(); }, function(){}); }catch(e){} }
  if(document.readyState==="complete"){ if("requestIdleCallback" in window) requestIdleCallback(warm,{timeout:4000}); else setTimeout(warm,1200); }
  else window.addEventListener("load",function(){ if("requestIdleCallback" in window) requestIdleCallback(warm,{timeout:4000}); else setTimeout(warm,1200); },{once:true});

  log("ready", CFG);
})();